import {
  INTEGRATION_MODEL,
  INTEGRATION_MODEL_UID,
  INTEGRATION_SERVICE
} from "utils/constants/metadata";
import { PRODUCT } from "utils/constants/models";

export const prepareImportFromServiceProduct = ({
  name,
  images,
  prices,
  metadata
}) => {
  const result = {
    name
  };

  if (images && images.length) {
    result.images = images;
  }
  if (prices && prices.length) {
    result.prices = prices.map(
      ({ formattedPrice, currency, recurring, metadata }) => ({
        formattedPrice,
        currency,
        recurring,
        metadata
      })
    );
  }
  if (metadata) {
    result.metadata = metadata;
  }

  return result;
};

export const matchingImport = ({ merchantProducts, product, integration }) =>
  merchantProducts &&
  merchantProducts.find(({ metadata }) => {
    const idMatch = metadata[INTEGRATION_MODEL_UID] === product.id;

    return (
      metadata[INTEGRATION_SERVICE] === integration.service &&
      metadata[INTEGRATION_MODEL] === PRODUCT &&
      idMatch
    );
  });
